import React from "react";
import Page from "./pages/index";
import { Route, Switch } from "react-router-dom";
import NotFound from "./NotFound";

const { Fragment } = React;

const Main = () => {
  return (
    <Fragment>
      <Switch>
        <Route exact path="/" component={Page} />
        <Route path="/:slug" component={Page} />
        <Route component={NotFound} />
      </Switch>
    </Fragment>
  );
};

export default Main;
